import { apiFetch } from './api';
import { requestWith } from './http';
import { SavedCart, WishlistEntry } from '../types/api';

/** The signed-in shopper's saved cart and wishlist. */
export interface ShopperApi {
  cart(): Promise<SavedCart>;
  setCartQuantity(itemId: string, quantity: number): Promise<SavedCart>;
  removeCartLine(itemId: string): Promise<SavedCart>;
  clearCart(): Promise<void>;
  mergeCart(lines: ReadonlyArray<{ item_id: string; quantity: number }>): Promise<SavedCart>;
  wishlist(): Promise<readonly WishlistEntry[]>;
  addWish(itemId: string): Promise<void>;
  removeWish(itemId: string): Promise<void>;
  mergeWishlist(itemIds: readonly string[]): Promise<readonly WishlistEntry[]>;
}

const CART_ERROR = 'Could not update your bag. Please try again.';
const WISHLIST_ERROR = 'Could not update your wishlist. Please try again.';
const id = encodeURIComponent;
const request = <T>(path: string, init: Parameters<typeof requestWith>[2], fallbackError: string) =>
  requestWith<T>(apiFetch, path, { ...init, fallbackError });

export const shopperApi: ShopperApi = {
  cart: () => request('/cart', {}, CART_ERROR),
  setCartQuantity: (itemId, quantity) =>
    request(`/cart/items/${id(itemId)}`, { method: 'PUT', json: { quantity } }, CART_ERROR),
  removeCartLine: (itemId) => request(`/cart/items/${id(itemId)}`, { method: 'DELETE' }, CART_ERROR),
  clearCart: () => request('/cart', { method: 'DELETE' }, CART_ERROR),
  mergeCart: (lines) => request('/cart/merge', { method: 'POST', json: { lines } }, CART_ERROR),
  wishlist: () => request('/wishlist', {}, WISHLIST_ERROR),
  addWish: (itemId) => request(`/wishlist/${id(itemId)}`, { method: 'PUT' }, WISHLIST_ERROR),
  removeWish: (itemId) => request(`/wishlist/${id(itemId)}`, { method: 'DELETE' }, WISHLIST_ERROR),
  mergeWishlist: (itemIds) =>
    request('/wishlist/merge', { method: 'POST', json: { item_ids: itemIds } }, WISHLIST_ERROR),
};
